import React from 'react';
import { formatUserAvailabilityCycleItem, formatUserAvailabilityCycleList } from 'selectors/availability.selectors';
import UserCycleFormInput from './input';

const config = {
  init: {},
  // List Table
  list: {
    title: 'User Cycle',
    format: formatUserAvailabilityCycleList,
    commands: {
      showDelete: false,
      showAdd: false
    },

    // Deleting
    confirmMessage: () => (
      <div>
        <p>Are you sure you wish to delete the cycle associated with this user?</p>
        <p>This action cannot be undone.</p>
      </div>
    ),

    // Table Columns
    columns: [
      {
        title: 'Cycle',
        dataIndex: 'availability_cycle__name',
        sorter: true,
        defaultSortOrder: 'ascend'
      },
      {
        title: 'Start Date',
        dataIndex: 'start_datetime',
        sorter: true,
        defaultSortOrder: 'ascend',
        width: '220px',
        render: (text, record) => (record.start_datetime && record.start_datetime.isValid() ? record.start_datetime.format('DD-MM-YYYY HH:mm') : 'N/A')
      },
      {
        title: 'End Date',
        dataIndex: 'end_datetime',
        sorter: true,
        defaultSortOrder: 'ascend',
        width: '220px',
        render: (text, record) => (record.end_datetime && record.end_datetime.isValid() ? record.end_datetime.format('DD-MM-YYYY HH:mm') : 'N/A')
      }
    ],

    // List Filtering
    filters: {},
    customFilters: {
      availability_cycle__name: {
        filterDropdownVisible: false,
        filtered: false,
        contains: true,
        searchFields: ['availability_cycle__name'],
        searchValue: ''
      }
    },

    // List Sorting
    sorter: {
      field: 'availability_cycle__name',
      order: 'ascend'
    }
  },

  // Detail Screen
  detail: {
    title: 'User Cycle',
    emptyMessage: 'Please select a Record',
    format: formatUserAvailabilityCycleItem,

    // Detail component to render
    component: props => (
      <UserCycleFormInput
        title="User Cycle"
        inputFormItemLayout={{
          inputLayout: {
            labelCol: {
              xs: { span: 24 },
              sm: { span: 8 }
            },
            wrapperCol: {
              xs: { span: 24 },
              sm: { span: 16 }
            }
          },
          row: {
            gutter: 16
          },
          col: {
            span: 24
          }
        }}
        {...props}
      />
    )
  }
};

export default config;
